import { render, staticRenderFns } from "./LandingFooter.vue?vue&type=template&id=15ed63d7&scoped=true"
import script from "./LandingFooter.vue?vue&type=script&lang=js"
export * from "./LandingFooter.vue?vue&type=script&lang=js"
import style0 from "./LandingFooter.vue?vue&type=style&index=0&id=15ed63d7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ed63d7",
  null
  
)

export default component.exports